import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
// import Header from "./headerstatus";
import Input from "../common/inputfunction";
import RenderButton from "../common/button";
import Sensor from "./sensor";
import Showimage from "./modalshowimage";
import ShowLPR from './modallprlist'
import Renderlpr from "./renderlpr";
import moment from "moment";
import Modalweightlist from './modalshowweightlist'
import DatePicker from "react-datepicker";

import {
  gettruckdaily,
  gettruckscaleinfor,
  getLastLPR,
  gettruckperhour,getlprmonthly,getlprweekly,getweightdetail,getlprdetail,getcctv
} from "../../services/truckscale";
import ReportCreate from "../chart/reportCreator";
import ProgressChart from "../chart/progresschart.js";
import Piechart from "../chart/piechart.js";

import BranchContext from "../context/branch";
import ConfirmDelete from "../common/confirmDelete";
import ConfirmSave from "../common/confirmSendFace";

import { toast } from "react-toastify";
import ScrollToTop from "../common/ScrollToTop";
import ProgressBar from "../common/progressbar";
import Button from "../common/button";

const Truckdetail = (props) => {
  //console.log(props);
  const [Id, setId] = useState(props.match.params.id);
  const { currentBranch } = useContext(BranchContext);
  const [name, setname] = useState("");
  const [search, setsearch] = useState("");
  const [status, setstatus] = useState(0);
  const [cardid, setCardId] = useState("");
  const [all, setall] = useState("btn btn-warning");
  const [imageUrl, setImageUrl] = useState("");
  const [dailylist, setdailylist] = useState([]);
  const [hourlist, sethourlist] = useState([]);
  const [lprmlist, setlprmlist] = useState([]);
  const [lprwlist, setlprwlist] = useState([]);
  const [lprdetaillist, setlprdetaillist] = useState([]);
  const [cctvlist, setcctvlist] = useState([]);
  

  const [detaillist, setdetaillist] = useState([]);
  const [data1, setData1] = useState({});
  const [data2, setData2] = useState({});
  const [data3, setData3] = useState({});
  const [percen, setpercen] = useState([]);
  const [truckinfo, settruckinfo] = useState({});
  const [lprdata, setlprdata] = useState({});
  const [facename, setfacename] = useState("");
  const [hour, sethour] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [total, setTotal] = useState(0);
  const [userlist, setuserlist] = useState([]);
  const [lastupdate, setlastupdate] = useState(new Date());
  const [startdate, setstartdate] = useState(new Date());
  const [showonscroll, setshowonscroll] = useState(false);
  const [showprogress, setshowprogress] = useState(false);
  const [completed, setcompleted] = useState(50);
  const [onprocess, setonprocess] = useState(false);
  const [chartprogress, setchartprogress] = useState([]);
  const [chartdatacomparetotal, setchartdatacomparetotal] = useState({});

  const [isOpen, setisOpen] = useState(false);
  const [isOpenLprlist, setisOpenLprlist] = useState(false);
  const [isOpenweighlist, setisOpenweighlist] = useState(false);
  const [isSaveOpen, setisSaveOpen] = useState(false);
  const [show, setshow] = useState(false);
  const [lprreport, setlprreport] = useState({startdate:"",typeid:0});

  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    const loadData = async () => {
      const { data: result } = await gettruckscaleinfor(Id);

      if (result.status === "success") {
        settruckinfo(result.data);
      }
    };
    loadData();
  }, [currentBranch, Id]);


  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    if (!truckinfo) return;
    if (truckinfo.readerid && truckinfo.readerid === 2) {
      const loadData = async () => {
        const { data: result } = await getLastLPR(
          truckinfo.truckname,
          truckinfo.branchid
        );
        if (result.status === "success") {
          setlprdata(result.data);
        }
      };
      loadData();
    }
  }, [currentBranch, Id, truckinfo]);


  useEffect(() => {
    if (!Id) return

    const loadData = async () => {
      try {
        const { data: result } = await getcctv(Id);

        if (result.status ==="success") {
          setcctvlist(result.data.list);
        } else {
          setcctvlist([]);
        }
      } catch (ex) {
        
      }
    };
    loadData();
  }, [Id,]);


  useEffect(() => {
    if (!currentBranch) return;
    if (!lprreport.startdate) return;
    if (!truckinfo) return;
      const loadData = async () => {
        const { data: result } = await getlprdetail(
          moment(lprreport.startdate, "YYYY-MM-DD").format("YYYY-MM-DD"),lprreport.typeid,truckinfo.truckname,
          truckinfo.branchid
        );
        if (result) {
          setlprdetaillist(result);
         
        }
      };
      loadData();
    
  }, [currentBranch, lprreport.startdate,truckinfo,lprreport.typeid]);


  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    if (!truckinfo) return;
    if (!hour) return
      const loadData = async () => {
        const { data: result } = await getweightdetail(
          truckinfo.truckname,
          truckinfo.branchid,hour, moment(startdate, "YYYY-MM-DD").format("YYYY-MM-DD")
        );
        if (result) {
           setdetaillist(result);
          
         }
      };
      loadData();
    
  }, [currentBranch, Id, truckinfo,hour,startdate]);



  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    if (!truckinfo) return;
    if (truckinfo.readerid && truckinfo.readerid === 2) {
      const loadData = async () => {
        const { data: result } = await getlprmonthly(
          truckinfo.truckname,
          truckinfo.branchid
        );
        if (result) {
          setlprmlist(result);
        }
      };
      loadData();
    }
  }, [currentBranch, Id, truckinfo]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    if (!truckinfo) return;
    if (truckinfo.readerid && truckinfo.readerid === 2) {
      const loadData = async () => {
        const { data: result } = await getlprweekly(
          truckinfo.truckname,
          truckinfo.branchid
        );
        if (result) {
          setlprwlist(result);
        }
      };
      loadData();
    }
  }, [currentBranch, Id, truckinfo]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    const loadData = async () => {
      const { data: result } = await gettruckdaily(Id);

      if (result) {
        setdailylist(result);
      }
    };
    loadData();
  }, [currentBranch, Id]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!Id) return;
    const loadData = async () => {
      const { data: result } = await gettruckperhour(
        Id,
        moment(startdate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );
      if (result) {
        sethourlist(result);
      }
    };
    loadData();
  }, [currentBranch, Id, startdate]);

  useEffect(() => {
    if (!dailylist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      for (const dataObj of dailylist) {
        label.push(dataObj.DDATE);
        total.push(parseInt(dataObj.total));
      }
      const data = {
        series: [{ name: "ทั้งหมด", data: total }],
        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        yLabels: label,
        headers: "ข้อมูลผลการชั่งย้อนหลัง 30 วัน ",
        type: "bar",
        stacked: true,
      };
      setData1(data);
    };
    chart();
  }, [dailylist, currentBranch]);

  useEffect(() => {
    if (!hourlist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      for (const dataObj of hourlist) {
        label.push(dataObj.hour);
        total.push(parseInt(dataObj.total));
      }
      const data = {
        series: [{ name: "ทั้งหมด", data: total }],
        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        yLabels: label,
        headers: "ข้อมูลการชั่ง แยกตามชั่วโมง",
        type: "bar",
        stacked: true,
      };
      setData2(data);
    };
    chart();
  }, [hourlist, currentBranch]);

  useEffect(() => {
    if (!lprmlist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      let right = [];
      let addnew = [];
      let edit = [];
      let datacompare=[]
      let totaledit= 0
      let totoladdnew=0
      let totalright =0
      for (const dataObj of lprmlist) {
        label.push(dataObj.ddate);
        total.push(parseInt(dataObj.total));
        edit.push(parseInt(dataObj.edittotal));
        addnew.push(parseInt(dataObj.createnew));
        right.push(parseInt(dataObj.readright));
        totalright = totalright + parseInt(dataObj.readright)
        totoladdnew = totoladdnew + parseInt(dataObj.createnew)
        totaledit =totaledit +parseInt(dataObj.edittotal)
      }
      const data = {
        series: [
          { name: "อ่านถูกต้อง", data: right },
          { name: "แก้ไข", data: edit },
          { name: "สร้างใหม่", data: addnew },
        ],
        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        yLabels: label,
        headers: "ข้อมูลการทำงาน LPR",
        type: "bar",
        stacked: true,
      };

      const data2 = {
        series: [totalright,totaledit,totoladdnew],
        yLabels: ["ถูกต้อง", "แก้ไข","สร้างใหม่"],
        headers: "เปรียบเทียบ ไม่ Scan / Scan )",
        type: "pie",
        stacked: true,
      };
      setchartdatacomparetotal(data2);

      setData3(data);
    };
    chart();
  }, [lprmlist, currentBranch]);



  useEffect(() => {
    if (!lprwlist || !currentBranch) return;
    const chart = () => {
   
      let total = [];
     
      for (const dataObj of lprwlist) {
       
        total.push(parseInt(dataObj.percen));
      
      }
      setpercen(total)
   


     
    };
    chart();
  }, [lprwlist, currentBranch]);


  // useEffect(() => {
  //   setuserlist([]);
  // }, [
  //   currentBranch,
  //   pageSize,
  //   search,
  //   Id,
  //   status,
  //   lastupdate,
  //   showonscroll,
  //   onprocess,
  // ]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (!Id) return;

  //   const loadData = async () => {
  //     const { data: result } = await getdevice(Id);
  //     if (result.status === "success") {

  //       setfacename(result.data.list[0].face_name);

  //     }
  //   };
  //   loadData();
  // }, [currentBranch, Id]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (onprocess) return;
  //   if (!Id) return;
  //   if (!pageSize || !pageNumber) return;
  //   setLoading(true);
  //   setError(false);
  //   setshowprogress(true);
  //   const loadData = async () => {
  //     const { data: result } = await getuserondevice(
  //       Id,
  //       status,
  //       search,
  //       pageSize,
  //       pageNumber
  //     );
  //     if (result.status === "success") {
  //       setTotal(result.data.total);
  //       setshowprogress(false);
  //       setuserlist((prevData) => {
  //         return [...new Set([...prevData, ...result.data.list])];
  //       });
  //       setHasMore(result.data.list.length > pageSize - 1);
  //       setLoading(false);
  //     }
  //   };
  //   loadData();
  // }, [
  //   currentBranch,
  //   Id,
  //   status,
  //   search,
  //   pageSize,
  //   pageNumber,
  //   lastupdate,
  //   showonscroll,
  //   onprocess,
  // ]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }

      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  // const confirmSave = () => {
  //   const doc = { face_id: Id, card_id: cardid };
  //   setonprocess(true);
  //   SaveData(doc);
  // };
  const handleOnClick = (cardid) => {
    setCardId(cardid);
    setisSaveOpen(true);

    // setonprocess(true);
  };

  // const SaveData = async (doc) => {
  //   try {
  //     const { data: result } = await updatefacedata(doc);
  //     // console.log(doc)

  //     if (result.status === "success") {
  //       toast.success("บันทึกเสร็จเรียบร้อย");
  //       setonprocess(false);
  //       setisSaveOpen(false);
  //       setstatus(0);
  //     } else {
  //       toast.error(result.message);
  //       setonprocess(false);
  //     }
  //   } catch (error) {
  //     // toast.error("Error");
  //     setonprocess(false);
  //   }
  // };

  // const SaveDelete = async (doc) => {
  //   try {
  //     const { data: result } = await updatesenddeleted(doc);
  //     if (result.status === "success") {
  //       toast.success("บันทึกเสร็จเรียบร้อย");
  //       setstatus(0);
  //       setonprocess(false);
  //     } else {
  //       toast.error(result.message);
  //       setonprocess(false);
  //     }
  //   } catch (error) {
  //     toast.error("Error");
  //     setonprocess(false);
  //   }
  // };
  const handleTextchange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleChange = (event) => {
    // setsearch(name)
    setstatus(event);
    setPageNumber(1);
    //    console.log('Click event',pageNumber);
  };
  const handleSearchClick = () => {
    setsearch(name);
    setPageNumber(1);
  };
  const onUpdate = () => {
    setlastupdate(new Date());
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setsearch(name);
    }
  };
  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };
  const handelDelete = (event) => {
    setCardId(event);
    setisOpen(true);
    // setonprocess(true);
    // const doc = { face_id :Id, card_id : event}

    // SaveDelete(doc);
  };

  // const confirmDelete = () => {
  //   setonprocess(true);
  //   setisOpen(false);
  //   const doc = { face_id: Id, card_id: cardid };

  //   SaveDelete(doc);
  // };
  const handleonCancel = () => {
    setisOpen(false);
  };
  const handleonCancelSave = () => {
    setisSaveOpen(false);
  };
  const handleonClick = () => {};
  const handleonHourClick = (hour) => {
    sethour(hour)
    setisOpenweighlist(true);
  };
  const handleonLPRGhaph = (id, event) => {
    setlprreport({startdate: id,typeid:event})
    setisOpenLprlist(true);
  };

  const handelClose = () => {
    setisOpen(false);
  };
  const handleClick = (url) => {
    setImageUrl(url);
    setisOpen(true);
  };
  const handleChangStartDate = (value) => {
    setstartdate(value);
  };
 const chartopions = {
    theme: {
      mode: "light",
      palette: "palette8",
      monochrome: {
        enabled: false,
        color: "#255aee",
        shadeTo: "light",
        shadeIntensity: 0.65,
      },
    },
  };
const handelWeighClosed = () => {
  setisOpenweighlist(false)
}
const onClose = () => {
setisOpenLprlist(false)
}
const handleImageClick = (event) => {
  setImageUrl(event);
  setisOpen(true);
}
const handleShowClick = () => {
  setshow(!show)
}
  return (
    <>
    <ShowLPR
     isOpen={isOpenLprlist} handleClick ={handleImageClick} onCancel={onClose} list={lprdetaillist} 
    />

<Showimage
     isOpen={isOpen} onCancel={handelClose} list={imageUrl} 
    />

      < Modalweightlist isOpen={isOpenweighlist} onCancel={handelWeighClosed} list={detaillist} />
      <div className="row">
        <div className="col-lg-6">
          <div className="d-flex justify-content-center">
            <span
              className="badge rounded-pill bg-warning"
              style={{ fontSize: "16px" }}
            >
              ข้อมูลการทำงานชั่งน้ำหนัก {truckinfo.name}{" "}
            </span>
          </div>
        </div>

        <div className="col-auto">
          <i>
            วันที่ <span className="label label-default"></span>
          </i>

          <div className="mt-1" style={{ marginTop: 20, marginBottom: 10 }}>
            <DatePicker
              todayButton="Today"
              dateFormat="dd/MM/yyyy"
              selected={startdate}
              onChange={handleChangStartDate}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mt-1">
            {data2.series !== undefined && (
              <ReportCreate
                data={data2}
                type={"bar"}
                labelposition="top"
                palette={"palette1"}
                onclick={handleonHourClick}
              />
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mt-1">
            {data1.series !== undefined && (
              <ReportCreate
                data={data1}
                type={"bar"}
                labelposition="top"
                palette={"palette1"}
                onclick={handleonClick}
              />
            )}
          </div>
        </div>
      </div>

      {truckinfo.readerid === 2 ? (
        <>
          <div className="d-flex m-1 justify-content-center m-3">
            <span className="badge rounded-pill bg-info ">
              <span className="fs-6 mx-2 my-2"> ข้อมูลการทำงาน ระบบ LPR </span>
            </span>
          </div>

  <>

  <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                 ผลการอ่านในรอบ 1 สัปดาห์
                </div>
                <div className="card-body text-center">
                  <ProgressChart
                    labels={["ความถูกต้อง"]}
                    donutData={percen}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  ภาพรวมย้อนหลัง 30 วัน
                </div>
                <div className="card-body text-center">
                  {chartdatacomparetotal.series !==undefined && chartdatacomparetotal && chartdatacomparetotal.series.length > 0 ? <Piechart
                    labels={chartdatacomparetotal.yLabels}
                    Datachart={chartdatacomparetotal.series}
                    chartOptions={chartopions}
                  />:null}
                </div>
              </div>
            </div>
          </div>
        </div>
        

  <div className="col-12">
    <div className="mt-1">
            {data3.series !== undefined && (
              <ReportCreate
                data={data3}
                type={"bar"}
                labelposition="top"
                // stacked = {true}
                palette={"palette1"}
                onclick={handleonLPRGhaph}
              />
            )}
          </div>
        </div>

        <Renderlpr item={lprdata} handleClick={handleClick} />
  </>
         
        </>
      ) : null}

      <div className="d-flex m-1 justify-content-center">
        <span className="fs-6 text-center badge rounded-pill bg-info mt-2">
          <button className="mx-5 btn btn-warning text-dark" onClick={() => handleShowClick()}>สถานะแท่นชั่ง/click เพื่อโชว์ภาพสด </button>
        </span>
      </div>
      <Sensor show ={show} cctvlist={cctvlist} name={truckinfo.name} /> 
    </>
  );
};

export default Truckdetail;
